export default "__VITE_ASSET__BE_oR8Oz__"